/**
 * Card — the base surface. Soft rounded container. `pop` adds the chunky
 * sticker shadow; `accent` paints a top edge in a brand color.
 */
export function Card({ children, pop = false, accent, padding = 'var(--space-5)', style, ...rest }) {
  return (
    <div style={{
      background: 'var(--surface-card)',
      border: '2px solid var(--border)',
      borderRadius: 'var(--radius-lg)',
      boxShadow: pop ? 'var(--shadow-pop)' : 'var(--shadow-sm)',
      padding,
      borderTop: accent ? `5px solid ${accent}` : '2px solid var(--border)',
      ...style,
    }} {...rest}>
      {children}
    </div>
  );
}
